import ConfirmDialog from '@/commons/confirm-dialog/ConfirmDialog';
import { Iconic } from '@/commons/iconic';
import { ActionsProps } from '@/components/Table/types/actions';
import { PATH_DASHBOARD } from '@/routes/paths';
import { Button, MenuItem } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { changeStatusProduct } from '@/services';
import { translates } from '@/utils';
import { Button as ButtonPorky} from '@PorkyCol/button';

export const ListActionsProducts = ({
  value,
  openConfirm,
  setOpenConfirm,
  setOpenPopover,
}: ActionsProps) => {
  const navigate_products: any = {
    view: PATH_DASHBOARD.products.view,
    edit: PATH_DASHBOARD.products.edit,
  };
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync: mutateDelete } = useMutation({
    mutationFn: changeStatusProduct,
    mutationKey: ['products', value],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
  });
  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleEdit = () => {
    navigate(navigate_products.edit(value));
  };
  const onDeleteRow = async () => {
    await mutateDelete(value);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <MenuItem onClick={handleEdit}>
        <Iconic icon="eva:edit-fill" />
        {translates.edit}
      </MenuItem>
      <Button
        onClick={() => {
          handleOpenConfirm();
        }}
        sx={{ color: 'error.main' }}
      >
        <Iconic icon="material-symbols:change-circle-outline" />
        {translates.status}
      </Button>

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title={translates.change}
        content={translates.messageChangeStatusProduct}
        action={
          <ButtonPorky
            variant="solid"
            color="danger"
            onClick={() => {
              onDeleteRow();
              handleClosePopover();
            }}
          >
            {translates.change}
          </ButtonPorky>
        }
      />
    </>
  );
};
